import { ApolloError } from '@apollo/client';
import { notification } from 'antd';
import { callTypeOptions } from '../constants/purchase-number.constant';
import { availablePhoneNumbersQueryVariables } from '@/types/generated/graphql';

export const findNumberTypeByValue = (value?: string | null) => {
  const defaultValue = callTypeOptions[0];
  if (value == null) return defaultValue;
  return callTypeOptions.find((item) => item.value === value) ?? defaultValue;
};

export function removeFalsyValues<T extends Record<string, unknown>>(object: T, removeFalse = false): T {
  const result = { ...object };

  for (const key in result) {
    const value = result[key];

    if (removeFalse) {
      if (!value) delete result[key];
    } else {
      if (!value && value !== false) delete result[key];
    }
  }

  return result as T;
}

export const simpleErrorCallback = (error: ApolloError) => {
  notification?.warning({
    message: 'Something went wrong',
    description: error?.message,
  });
};

export const getNumberTypeLabel = (value?: string | null) => {
  const foundType = callTypeOptions.find((type) => type.value === value);
  if (foundType) return foundType.label;
  return 'n/a';
};

export function formatPhoneNumberPattern(
  partialNumber: string,
  matchPosition: 'first' | 'last' | 'any',
  dialingCode?: string
): string {
  if (matchPosition === 'first') {
    const code = dialingCode ?? '';
    const wildcards = '*'.repeat(Math.max(0, 10 - partialNumber.length));
    return `${code}${partialNumber}${wildcards}`.trim();
  }
  if (matchPosition === 'last') return `${partialNumber}$`;
  return partialNumber;
}

export const ADDRESS_REQUIREMENT_MAP: Record<string, Partial<availablePhoneNumbersQueryVariables>> = {
  none: { excludeAllAddressRequired: true },
  excludelocal: { excludeLocalAddressRequired: true },
  excludeforeign: { excludeForeignAddressRequired: true },
};
